// Validação dos dois campos da caixa do Google Chat, no formulário (GCHAT-01, 2.1). O servidor
// valida de novo; aqui é para quem digita saber antes do envio.

// O número do projeto é só dígitos (Console do Google Cloud → Painel do projeto). Quem cola o
// ID do projeto (`meu-projeto-123`) no lugar dele erra aqui, e não depois, no teste.
export const eNumeroDeProjeto = valor =>
  /^\d+$/.test(String(valor ?? '').trim());

// Toda service account do Google termina em `gserviceaccount.com`, com um subdomínio antes:
// `iam.` (as criadas no projeto), `developer.` (a padrão do Compute), `appspot.`.
export const eEmailDeServiceAccount = valor =>
  /^[^\s@]+@[^\s@]+\.gserviceaccount\.com$/i.test(String(valor ?? '').trim());
